import 'whatwg-fetch'

let stack = []
let listeners = []

export function subscribeToRequests(callback) {
  listeners.push(callback)

  return callback
}

export function unsubscribeFromRequests(handle) {
  listeners = listeners.filter((listener) => listener !== handle)
}

function notify() {
  listeners.forEach((listener) => listener(stack))
}

function addToStack(reqID, url, method) {
  stack.push({reqID, url, method})

  notify()
}

function removeFromStack(reqID) {
  stack = stack.filter((item) => item.reqID !== reqID)

  notify()
}

export function getActiveRequests() {
  return stack
}

export function formatErrorMessage(param, message, status) {
  if (param && message) {
    return `${param}: ${message}`
  }
  if (message) {
    return message
  }
  return `${status}`
}

function getErrorMessage(response) {
  if (!response.json) {
    return response.text
  }
  return response.json.error_message || response.json.message
}

function getErrorParam(response) {
  if (!response.json) {
    return null
  }
  return response.json.param
}

function getError(res) {
  const param = getErrorParam(res)
  const errorMessage = getErrorMessage(res)

  return {
    message: formatErrorMessage(param, errorMessage, res.response.status),
    error_message: errorMessage,
    param: param,
    response: res,
  }
}

let reqID = 0

export async function ordoroFetch(method, url, data, options = {}) {
  let thisReqID = (reqID += 1)
  const handleResponse = options.handleResponse !== false

  method = method.toLowerCase()
  let body

  if (method !== 'get') {
    body = data
  }

  const contentType = body instanceof FormData ? undefined : 'application/json'

  const headers = {Accept: 'application/json', ...options.headers}

  if (contentType === 'application/json') {
    headers['Content-Type'] = contentType

    body = JSON.stringify(body)
  }

  addToStack(thisReqID, url, method)

  let res

  try {
    res = await window.fetch(url, {
      method: method.toUpperCase(),
      credentials: 'include',
      ...options,
      headers,
      body,
    })
  } finally {
    removeFromStack(thisReqID)
  }

  // Rate and label requests for amazon could return with 401 if account creds fail
  // We should fix this in the API but here I am
  if ((res.status === 401 || res.status === 503) && !url.match(/amazon$/)) {
    const url = new URL(window.location.origin + '/login')
    url.search = new URLSearchParams({redirect: window.location.href})
    window.location = url
  }

  const resContentType = res.headers.get('Content-Type')
  const responseType = resContentType.match('application/json')
    ? 'json'
    : resContentType.match(/application/)
      ? 'blob'
      : 'text'

  const response = {
    response: res,
    status: res.status,
    json: undefined,
    blob: undefined,
    text: undefined,
  }

  if (handleResponse) {
    if (responseType === 'json') {
      response.json = await res.json()
    } else if (responseType === 'blob') {
      response.blob = await res.blob()
    } else {
      response.text = await res.text()
    }

    if (!res.ok) {
      throw getError(response)
    } else if (responseType === 'json' && !response.json) {
      throw getError({
        ...response,
        json: {error_message: 'No JSON payload returned'},
      })
    }
  }

  return response
}

export function ordoroFetchHead(url, data, options) {
  return ordoroFetch('head', url, data, options)
}

export function ordoroFetchGet(url, data, options) {
  return ordoroFetch('get', url, data, options)
}

export function ordoroFetchPut(url, data, options) {
  return ordoroFetch('put', url, data, options)
}

export function ordoroFetchPost(url, data, options) {
  return ordoroFetch('post', url, data, options)
}

export function ordoroFetchDelete(url, data, options) {
  return ordoroFetch('delete', url, data, options)
}
